function parseCarNumber(value) {
    const raw = String(value ?? "").replace("#", "").trim();
    if (!raw) return null;

    const match = raw.match(/\d+/);
    if (!match) return null;

    const number = Number.parseInt(match[0], 10);
    return Number.isFinite(number) ? number : null;
}

export function getDriverCarNumber(entry) {
    if (!entry) return null;

    const directCandidates = [
        entry.car_number,
        entry.carNumber,
        entry.driver?.car_number,
        entry.driver?.carNumber,
        entry.season_driver?.car_number,
        entry.seasonDriver?.car_number,
        entry.season_entries?.[0]?.car_number,
        entry.seasonEntries?.[0]?.car_number,
    ];

    for (const candidate of directCandidates) {
        const parsed = parseCarNumber(candidate);
        if (parsed !== null) return parsed;
    }

    const labelCandidates = [
        entry.label,
        entry.driver_label,
        entry.driver_name,
        entry.display_name,
        entry.name,
    ];

    for (const label of labelCandidates) {
        const match = String(label ?? "").match(/#\s*(\d+)/);
        if (!match) continue;
        const parsed = parseCarNumber(match[1]);
        if (parsed !== null) return parsed;
    }

    return null;
}

export function getPersonName(entry) {
    if (!entry) return "";

    const value =
        entry.driver_name ??
        entry.driver_label ??
        entry.display_name ??
        entry.iracing_name ??
        entry.name ??
        entry.driver?.display_name ??
        entry.driver?.iracing_name ??
        entry.linked_driver?.display_name ??
        entry.discord_global_name ??
        entry.discord_username ??
        entry.email ??
        entry.label ??
        "";

    return String(value)
        .replace(/^#?\s*\d+\s*(?:[·/|-]\s*)?/i, "")
        .replace(/\s*\((PRO|INT|AM)\)\s*$/i, "")
        .trim();
}

export function comparePeopleByFirstName(a, b) {
    const aName = getPersonName(a);
    const bName = getPersonName(b);

    const aFirst = (aName.split(/\s+/)[0] || "").trim();
    const bFirst = (bName.split(/\s+/)[0] || "").trim();

    const firstCompare = aFirst.localeCompare(bFirst, "de", {
        numeric: true,
        sensitivity: "base",
    });

    if (firstCompare !== 0) return firstCompare;

    return aName.localeCompare(bName, "de", {
        numeric: true,
        sensitivity: "base",
    });
}

export function compareDriversByCarNumber(a, b) {
    const aNumber = getDriverCarNumber(a);
    const bNumber = getDriverCarNumber(b);

    if (aNumber !== null && bNumber !== null && aNumber !== bNumber) {
        return aNumber - bNumber;
    }

    if (aNumber !== null && bNumber === null) return -1;
    if (aNumber === null && bNumber !== null) return 1;

    return comparePeopleByFirstName(a, b);
}

export function sortDriversByCarNumber(items) {
    return [...(Array.isArray(items) ? items : [])].sort(compareDriversByCarNumber);
}

export function sortPeopleByFirstName(items) {
    return [...(Array.isArray(items) ? items : [])].sort(comparePeopleByFirstName);
}
